export default __webpack_public_path__ + "static/media/serviciosAlarma2.e5f625ab.png";